<template>
  <div class>
    <drawer :title="addEditTitle" :dialogShow="addEditShow" @handleChange="back">
      <div slot="body">
        <div class="pay-mains">
          
          <div v-if="form.orderType == 'reserve'">
            <p class="title titles-head" v-if="form.orderStatus !== 'waitPay'">预约信息</p>
            <div class="totals-box" v-if="form.orderStatus !== 'waitPay'">
              <div class="flex-row">
                <div class="itemName">到店人</div>
                <div class="itemNum">{{ form.reserveInfo.arriveName }}</div>
              </div>
              <div class="box">
                <div class="itemName">预约手机号</div>
                <div class="itemNum">{{ form.reserveInfo.arriveMobile }}</div>
              </div>
              <div class="box">
                <div class="itemName">下单时间</div>
                <div class="itemNum">{{ formatDate(form.reserveInfo.oxCtime) }}</div>
              </div>
              <div class="box" v-if="form.orderStatus == 'cancel'">
                <div class="itemName">取消时间</div>
                <div class="itemNum">{{ formatDate(form.reserveInfo.oxLtime) }}</div>
              </div>
              <div class="box" v-if="form.orderStatus == 'waitConsume'">
                <div class="itemName">预约到店时间</div>
                <div class="itemNum">{{ formatDate(form.reserveInfo.arriveTime) }}</div>
              </div>
              <div class="box" v-else>
                <div class="itemName">完成时间</div>
                <div class="itemNum">{{ formatDate(form.reserveInfo.oxLtime) }}</div>
              </div>
            </div>
          </div>
          <p class="order-title-boxs"><span class="blueBlock"></span><i>订单信息</i></p>
          <div class="totals-box pl24">
            <div class="flex-row mb30">
              <div class="itemName">订单状态</div>
              <div class="itemNum" :class="form.orderStatus == 'waitPay' ? '':'jishi'">{{ form.orderStatusCn }}</div>
            </div>
            <div class="flex-row mb30">
              <div class="itemName">订单编号</div>
              <div class="itemNum">{{ form.id }}</div>
            </div>
            <div class="flex-row mb30">
              <div class="itemName">下单顾客</div>
              <div class="itemNum">{{ form.customerName }}&nbsp;{{ form.mobile }}</div>
            </div>
            <div class="flex-row mb30">
              <div class="itemName">持有折扣卡</div>
              <div class="itemNum">{{ form.ownDiscountDatas }}</div>
            </div>
            <div class="flex-row mb30">
              <div class="itemName">下单时间</div>
              <div class="itemNum">{{ formatDate(form.orderTime) }}</div>
            </div>
            <div class="flex-row mb30">
              <div class="itemName">支付状态</div>
              <div class="itemNum">{{ form.payStatusCn }}</div>
            </div>
            <div class="flex-row mb30">
              <div class="itemName">支付方式</div>
              <div class="itemNum">{{ form.payWayCn }}</div>
            </div>
            <div class="flex-row mb30" v-if="form.orderStatus == 'cancel'">
                <div class="itemName">取消时间</div>
                <div class="itemNum">{{ formatDate(form.oxLtime) }}</div>
              </div>
            <div class="flex-row mb30" v-else-if="form.orderStatus == 'finish'">
              <div class="itemName">完成时间</div>
              <div class="itemNum">{{ formatDate(form.oxLtime) }}</div>
            </div>
            <div class="flex-row mb30" v-else>
              <div class="itemName">支付时间</div>
              <div class="itemNum">{{ formatDate(form.payTime) }}</div>
            </div>
            <div class="flex-row mb30">
              <div class="itemName">操作人</div>
              <div class="itemNum">{{ form.oxLname }}</div>
            </div>
            <div class="flex-row mb30" v-if="form.rechargeNum || form.rechargeNum == 0">
              <div class="itemName">累计充值次数</div>
              <div class="itemNum">{{ form.rechargeNum }}</div>
            </div>
          </div>
          <div class="align-items">
            <p class="order-title-boxs">
              <span class="blueBlock"></span><i>订单明细</i>
            </p>
            <span class="jishi fontSize16 pr16 cur" @click="addProductDepost" v-if="form.depositFlag">产品寄存</span>
          </div>

          <div class="totals-box mlr24 ">
            <el-row class="order-details">
              <el-col :span="9" class="pl10">商品名称</el-col>
              <el-col :span="3">单价(元)</el-col>
              <el-col :span="2">数量</el-col>
              <el-col :span="3">小计</el-col>
              <el-col :span="4">折扣优惠</el-col>
              
              <el-col :span="3" class="tRight pr10">实付(元)</el-col>
            </el-row>
            <el-row v-for="(item,index) in form.orderItemVOList" :key="index" class="mt20">
               <el-row>
                <el-col :span="9" class="pl10">{{item.itemName}}</el-col>
                <el-col :span="3" class="color999">{{item.salePrice}}</el-col>
                <el-col :span="2" class="color999">{{item.itemNum}}</el-col>
                <el-col :span="3" class="color999">{{item.saleAmount}}</el-col>
                <el-col :span="4" class="color999">￥{{item.discountAmount}}<span v-if="item.discountRemark">({{ item.discountRemark }})</span></el-col>
                <el-col :span="3" class="tRight pr10">{{item.realPayAmount}}</el-col>
               </el-row>
           
              <el-row>
                <el-col :span="2" class="pl10 mt20 color999">技师</el-col>
                <el-col :span="22" class="mt20 tRight pr10">
                  <div class="jishi cur" v-if="form.orderSource == 'customerapp' && (form.orderStatus == 'waitConsume'|| form.orderStatus == 'waitExtract')" @click="selectedStaffs(item,index)">{{ item.staffNames?item.staffNames:'请选择' }}></div>
                    <div v-else class="jishi">{{item.staffNames}}</div>
                </el-col>
              </el-row>
            </el-row>
          </div>
          <p class="order-title-boxs" v-if="refundList.refundItemVOList.length != 0"><span class="blueBlock"></span><i>退款信息</i></p>
          <div class="totals-box mt20 pl24" v-if="refundList.refundItemVOList.length != 0">
            <div class="flex-row mb30">
              <div class="itemName">退款总金额</div>
              <div class="itemNum">￥{{ refundList.refundAmount }}</div>
            </div>
            <div class="flex-row mb30">
              <div class="itemName">本金退款</div>
              <div class="itemNum">￥{{ refundList.refundBaseAmount }}</div>
            </div>
            <div class="flex-row mb30">
              <div class="itemName">赠金退款</div>
              <div class="itemNum">￥{{ refundList.refundGiveAmount }}</div>
            </div>
          </div>
          <p class="order-title-boxs" v-if="refundList.refundItemVOList.length != 0"><span class="blueBlock"></span><i>退款明细</i></p>
          <div class="totals-box mlr24" v-if="refundList.refundItemVOList.length != 0">
            <el-row class="order-details">
              <el-col :span="10" class="pl10">商品名称</el-col>
              <el-col :span="3">数量</el-col>
              <el-col :span="4">退款</el-col>
              <el-col :span="4">社保补贴</el-col>
              <el-col :span="3" class="tRight pr10">扣除</el-col>
            </el-row>
            <el-row v-for="(item,index) in refundList.refundItemVOList" :key="index" class="mt20">
              <el-col :span="12" class="pl10 mb20 color999">审核状态</el-col>
              <el-col :span="12" class="mb20 tRight pr10">
                  <div class="jishi">{{item.auditStatusCn}}</div>
              </el-col>
              <el-col :span="10" class="pl10">{{item.itemName}}</el-col>
              <el-col :span="3" class="color999">{{item.itemNum}}</el-col>
              <el-col :span="4" class="color999">￥{{item.refundAmount}}</el-col>
              <el-col :span="4" class="color999">￥{{item.socialSubsidyAmount}}</el-col>
              <el-col :span="3" class="tRight pr10">￥{{item.deductAmount}}</el-col>
              <el-col :span="4" class="pl10 mt20 color999">技师</el-col>
              <el-col :span="20" class="mt20 tRight pr10">
                  <div class="jishi">{{item.staffNames}}</div>
              </el-col>
            </el-row>
          </div>
          <p class="order-title-boxs"><span class="blueBlock"></span><i>订单金额</i></p>
          <div class="totals-box pl24">
            <div class="flex-row mb30">
              <div class="itemName">总金额</div>
              <div class="itemNum">￥{{ form.orderAmount }}</div>
            </div>
            <div class="flex-row mb30">
              <div class="itemName">总数量</div>
              <div class="itemNum">{{ form.itemNum }}</div>
            </div>
            <div class="flex-row mb30">
              <div class="itemName">折扣金额</div>
              <div class="itemNum moneys decoration">￥{{ form.discountAmount }}</div>
            </div>
            <div class="flex-row mb30">
              <div class="itemName">卡券优惠</div>
              <div class="itemNum moneys decoration">￥{{ form.couponAmount }}</div>
            </div>
            <div class="flex-row mb30">
              <div class="itemName">实付总金额</div>
              <div class="moneys">￥{{ form.realPayAmount }}</div>
            </div>
            <div class="flex-row mb30">
              <div class="itemName">本金消费</div>
              <div class="moneys">￥{{ form.basePayAmount }}</div>
            </div>
            <div class="flex-row mb30">
              <div class="itemName">赠金消费</div>
              <div class="moneys">￥{{ form.givePayAmount }}</div>
            </div>
          </div>
          <p class="order-title-boxs" v-if="deductInfo.achievementList != 0"><span class="blueBlock"></span><i>提成明细</i></p>
          <div class="totals-box customTable" v-if="deductInfo.achievementList != 0">
            <div class="detail plr20">
              <el-table :data="deductInfo.achievementList" input-large header-cell-class-name="table_header_bgcolor">
                <el-table-column prop="staffName" label="店员姓名" width="80"></el-table-column>
                <el-table-column prop="itemName" label="商品信息" width="auto"></el-table-column>
                <!-- <el-table-column prop="itemAmount" label="商品金额" width="auto"></el-table-column> -->
                <!-- <el-table-column prop="itemNum" label="数量" width="70"></el-table-column> -->
                <el-table-column prop="achievementTotalAmount" label="业绩" width="80">
                    <template slot-scope="scope">
                        ￥{{scope.row.achievementTotalAmount}}
                    </template>
                </el-table-column>
                <el-table-column prop="deductTotalAmount" label="提成" width="80">
                    <template slot-scope="scope">
                        ￥{{scope.row.deductTotalAmount}}
                    </template>
                </el-table-column>
                <el-table-column prop="socialSubsidyAmount" label="社保补贴" width="80">
                    <template slot-scope="scope">
                        ￥{{scope.row.socialSubsidyAmount}}
                    </template>
                </el-table-column>
                <el-table-column prop="achieveType" label="业绩类型" width="80">
                  <template slot-scope="scope">
                    <p v-if="scope.row.achieveType == 'order'">开单</p>
                    <p v-if="scope.row.achieveType == 'refund'">退款</p>
                    <p v-if="scope.row.achieveType == 'invalid'">作废</p>
                    <p v-if="scope.row.achieveType == 'distribution'">分配</p>
                  </template>
                </el-table-column>
                <el-table-column label="登记时间" width="160" align="right">
                  <template slot-scope="scope">{{ formatDate(scope.row.oxCtime)}}</template>
                </el-table-column>
              </el-table>
            </div>
          </div>
          <print ref="print" class="prints"></print>
        </div>
        <div class="drawer-footer pr24 pb10" v-if="showFooter">
          <!--  v-if="form.cancelFlag" -->
            <!-- 取消标识-->
            <el-button class="ml10" v-if="form.orderStatus == 'finish'" @click="printReceipts">打印小票</el-button>
            <el-button v-if="form.cancelFlag" class="ml10" @click="cashierCancel" v-perm="{key:'orderInfo', value:'orderInfo:cancel'}">取消订单</el-button>
            <!-- 继续支付标识-->
            <el-button
              v-if="form.payFlag"
              class="ml10"
              type="primary"
              @click="cashierPay"
               v-perm="{key:'orderInfo', value:'orderInfo:continuePay'}"
            >继续收银</el-button>
            <!-- 核销 -->
            <el-button
              v-if="form.useConfirmFlag"
              class="ml10"
              type="primary"
              @click="cashierWaitConsume"
               v-perm="{key:'orderInfo', value:'orderInfo:o2oOrder'}"
            >核销订单</el-button>
            <!-- 作废 -->
            <el-button
              v-if="form.invalidFlag"
              class="ml10"
              type="primary"
              @click="cashierFinish"
               v-perm="{key:'orderInfo', value:'orderInfo:invalid'}"
            >作废订单</el-button>
            <!-- 修改提成 -->
            <el-button
              v-if="form.upDeductFlag"
              class="ml10"
              type="primary"
              @click="updateDeduct"
               v-perm="{key:'orderInfo', value:'orderInfo:updateDeduct'}"
            >修改提成</el-button>
            <!-- 退款 -->
            <el-button
              v-if="form.refundFlag"
              class="ml10"
              type="primary"
              @click="refundfinish"
               v-perm="{key:'orderInfo', value:'orderInfo:refund'}"
            >申请退款</el-button>
        </div>
      </div>
    </drawer>

    <addDeposit-set ref="addDepositForm" @change="addDeposit"></addDeposit-set>
    <staff-set ref="staffSetForm" @staffChange="changePage"></staff-set>
    <staff-set ref="deductSetForm" @staffChange="changeDeductPage"></staff-set>
    <pay-success
      ref="paySuccessForm"
      @change="handleChangePay"
      :sourceFrom="form.orderType == 'card'? 'card': 'order'"
      :source="form.orderType"
      :sources="'order'"
      :foots="false"
    ></pay-success>
    <update-deduct ref="updateDeductForm" @change="handleChangeDeductForm"></update-deduct>
    <payDialog title="核销订单" :hide="dialogHide" @changeDialog="savePay" :bizType="'orderUse'"  :mobile="merchantAppMemberVO && merchantAppMemberVO.mobile" :oid="form.id" :type="typeCate" :price="form.realPayAmount"></payDialog>
    <edit-refund ref="editSetForm" @change="handleChange"></edit-refund>
  </div>
</template>

<script>
import minxin from "../../assets/javascript/minxin.js";
import drawer from "../../components/common/drawer";
import payDialog from "../components/pay-dialog";
import staffSet from "../components/staff-set";
import deductSet from "../components/staff-set";
import updateDeduct from "./updateDeduct";
import editRefund from "./edit-refund";

import addDepositSet from "../datas/productDeposit/addDeposit.vue";
import print from "../components/print.vue";
// import paySuccess from "./pay-success";
import paySuccess from "../components/pay-success.vue";

import Dialog from "../../components/common/dialog.vue";
import { decrypt, encrypt } from "../../assets/javascript/untils";
export default {
  mixins: [minxin],
  components: {
    drawer,
    payDialog,
    staffSet,
    Dialog,
    editRefund,
    paySuccess,
    deductSet,
    updateDeduct,
    addDepositSet,
    print
  },
  props: {
      typeCate: {
          type: String,
          default: 'reserve'
      }
  },
  data() {
    return {
      addEditShow: false,
      addEditTitle: "订单详情",
      dialogHide: false,
      refundForm: {},
      orderInvalidForm: {},
      merchantAppMemberVO: {},
      form: {
        orderType: ""
      },
      dialogHide: false,
      setDeductAmount: 0,
      deductStaffList: [
        {
          deductAmount: null,
          staffName: "",
          staffId: ""
        }
      ], //提成列表
      refundList: {
        refundItemVOList: []
      },
      deductInfo: [],
      isPrint: false,
      showFooter: true,
    };
  },
  created() {
    
    this.init();
  },
  mounted() {
    if (JSON.parse(localStorage.getItem("payMobile"))) {
      let arr = JSON.parse(localStorage.getItem("payMobile"));
      if (arr.path == this.$route.path) {
        this.$refs["paySuccessForm"].$emit("set", arr);
      }
    }
    window.addEventListener('beforeunload', this.beforeunloadHandler, false)
  },
  destroy() {
    window.removeEventListener('beforeunload', this.beforeunloadHandler, false)
  },
  methods: {
    beforeunloadHandler(e) {
      // 监听网页刷新事件
      localStorage.removeItem("payMobile")
    },
    
    handleChangePay(org) {
        console.log(org);
      if (org) {
        this.$api.get(this.$url.orderInfo.get, {id: this.form.id}).then(res => {
            if (res) {
              this.addEditShow = true;
              this.form = res;
              this.form.orderTime = this.formatDate(this.form.orderTime);
              this.form.payTime = this.formatDate(this.form.payTime);
              this.form.oxCtime = this.formatDate(this.form.oxCtime);
              this.merchantAppMemberVO = this.form.orderMemberVO;
            }
          }).catch(error => {});
      }
    },
    //  页面初始化函数
    init() {
      this.$on("set", function (org) {
        let type = typeof org === "string";
        let id = type ? org : org.orderId;
        this.showFooter = type ? true : false;
        this.getDuctList(id);
        this.$api.get(this.$url.orderInfo.get, {
            id: id
          }).then(res => {
            if (res) {
              this.addEditShow = true;
              this.form = res;
              this.form.id = String(this.form.id)
              this.form.orderTime = this.formatDate(this.form.orderTime);
              this.form.payTime = this.formatDate(this.form.payTime);
              this.form.oxCtime = this.formatDate(this.form.oxCtime);
              this.merchantAppMemberVO = this.form.orderMemberVO;
              //this.merchantAppMemberVO = this.form.merchantAppMemberVO;
            }
          }).catch(error => {});
          this.$api.get(this.$url.companyRefund.listRefundItemByOrderId, {orderId: id}).then(ret => {
            if (ret) {
              this.refundList = ret
            }
          });
      });
    },
    getDuctList (org) {
        this.$api.get(this.$url.orderInfo.getAchievement, {id: org}).then(ret => {
            if (ret) {
                this.deductInfo = ret;
                this.deductInfo.orderId = org;
            }
        });
    },
    handleChangeDrawer() {
      this.addEditShow = false;
      this.$emit("change", true);
    },
    saveDeduct() {
      if (this.deductStaffList.length <= 0) {
        this.$message.warning("请添加提成");
        return false;
      }
      for (let i in this.deductStaffList) {
        if (this.deductStaffList[i].staffName == "") {
          this.$message.warning("请选择技师");
          return false;
        }
        if (this.deductStaffList[i].deductAmount == "") {
          this.$message.warning("请输入金额");
          return false;
        }
        if (this.deductStaffList[i].deductAmount < 1) {
          this.$message.warning("输入金额不能为0");
          return false;
        }
      }
      let arr = {
        orderId: this.form.id,
        millisecond: new Date().getTime(),
        deductStaffList: this.deductStaffList
      };
      // encrypt(JSON.stringify(arr))
      this.$api.post(this.$url.orderInfo.updateDeduct, encrypt(JSON.stringify(arr))).then(res => {
          if (res) {
            this.addEditShow = false;
            this.$message.success("操作成功");
            this.$emit("change", true);
          }
        });
    },
    addDeductStaffList() {
      this.deductStaffList.unshift({
        deductAmount: null,
        staffName: "",
        staffId: ""
      });
    },
    removeDeductStaffList(index) {
      this.deductStaffList.splice(index, 1);
    },
    setStaff(item, index) {
      this.$refs["deductSetForm"].$emit("set", {
        single: true,
        staffIds: item.staffId,
        index: index
      });
    },
    changeDeductPage(org) {
      this.deductStaffList[org.nodeId].staffId = org.staffIds[0].staffId;
      this.deductStaffList[org.nodeId].staffName = org.staffIds[0].staffName;
    },
    selectedStaffs(row, index) {
      let arr = [];
      if (row.saleStaffIds) {
        let obj = row.saleStaffIds.split(",");
        for (let i in obj) {
          arr.push({ staffId: obj[i] });
        }
      }
      this.$refs["staffSetForm"].$emit("set", {
        staffIds: arr,
        index: index
      });
    },
    changePage(org) {
      //value
      console.log(org)
      this.form.orderItemVOList[org.nodeId].saleStaffIds = "";
      this.form.orderItemVOList[org.nodeId].staffNames = "";
      for (let i in org.staffIds) {
        this.form.orderItemVOList[org.nodeId].saleStaffIds +=
          i == 0 ? org.staffIds[i].staffId : "," + org.staffIds[i].staffId;
        this.form.orderItemVOList[org.nodeId].staffNames +=
          i == 0 ? org.staffIds[i].staffName : "," + org.staffIds[i].staffName;
      }
      console.log(this.form.orderItemVOList)
    },
    cashierCancel() {
      //取消订单
      this.$confirm("确定要取消订单吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true
      })
        .then(() => {
          let arr = { orderId: this.form.id, cancelReason: "" };
          this.$api
            .post(this.$url.orderInfo.cancel, encrypt(JSON.stringify(arr)))
            .then(res => {
              if (res) {
                this.addEditShow = false;
                this.$message.success("操作成功");
                this.$emit("change", true);
              }
            })
            .catch(error => {});
        })
        .catch(() => {});
    },
    handleInvalChange(status) {
      //作废审核
      this.$confirm(status == "pass" ? "确定同意吗?" : "确定拒绝吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true
      })
        .then(() => {
          this.$api
            .get(this.$url.orderInfo.audit, {
              id: this.orderInvalidForm.id,
              auditStatus: status
            })
            .then(res => {
              if (res) {
                this.$router.push("/orderInvalid");
              }
            })
            .catch(error => {});
        })
        .catch(() => {});
    },
    cashierPay() {
      //继续收银
      if (this.form.memberId) {
        localStorage.setItem("payMobile", JSON.stringify({
          //会员充值进入界面调用
          id: this.form.id,
          mobile: this.form.orderMemberVO.mobile ? this.form.orderMemberVO.mobile : this.form.customerName,
          path: this.$route.path,
          res: this.form
        }))
      }
      console.log("zhixing");
      this.$refs["paySuccessForm"].$emit("set", this.form);
    },

    cashierWaitConsume() {
      //待消费
      for (let i in this.form.orderItemVOList) {
        if (
          this.form.orderItemVOList[i].saleStaffIds == null ||
          this.form.orderItemVOList[i].saleStaffIds == ""
        ) {
          this.$message.warning("请选择技师");
          return false;
        }
      }
      this.dialogHide = true;
    },
    savePay(value) {
      if (value != "") {
        let orderItemList = [];
        if (this.form.orderStatus == "waitConsume") {
          for (let i in this.form.orderItemVOList) {
            orderItemList.push({
              itemId: this.form.orderItemVOList[i].itemId,
              itemType: this.form.orderItemVOList[i].itemType,
              staffIds: this.form.orderItemVOList[i].saleStaffIds
            });
          }
        }
        let arr = {
          orderId: this.form.id,
          verifyCode: value.verifyCode,
          payCheckType: value.payCheckType,
          orderItemList: orderItemList
        };
        this.$api.post(this.$url.orderInfo.useConfirm, encrypt(JSON.stringify(arr))).then(res => {
            if (res) {
              this.dialogHide = false;
              this.addEditShow = false;
              this.$message.success("操作成功");
              this.$emit("change", true);
            }
          })
          .catch(error => {});
      } else {
        this.dialogHide = false;
      }
    },
    handleChangeDeductForm(org) {
        if (org) {
            this.getDuctList(org)
        }
    },
    refundfinish() {
      this.$refs["editSetForm"].$emit("set", this.form);
    },
    handleChange(bool) {
      if (bool) {
        this.addEditShow = false;
      }
    },
    updateDeduct() {
      this.$refs["updateDeductForm"].$emit("set", this.deductInfo);
    },
    printReceipts () {
      this.$refs["print"].$emit("set", {
        orderId: this.form.id,
        isPrint: true
      });
    },
    back () {
      localStorage.removeItem("payMobile")
      this.addEditShow = false;
      
    },
    cashierFinish() {
      // 订单作废
      this.$confirm("确定要作废订单吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true
      })
        .then(() => {
          this.$api
            .get(this.$url.orderInvalid.apply, {
              orderId: this.form.id
            })
            .then(res => {
              if (res) {
                // this.addEditShow = false;
                this.$message.success("申请成功,请等待管理员审核");
                // this.$emit("change", true);
              }
            })
            .catch(error => {});
        })
        .catch(() => {});
    },
    orderInvalid() {},
    // 上传组件成功回调
    // 保存
    save() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.$api.post(this.$url.orderInfo.save, this.form).then(res => {
            if (res) {
              this.$api.success();
            }
          });
        }
      });
    },
    addProductDepost() {
      this.$refs["addDepositForm"].$emit("set", {orderId:this.form.id,sourceFrom:"order"});
    },
    addDeposit() {

    },
  }
};
</script>
<style>
.payway-success .el-button + .el-button {
  margin-left: 0;
}
</style>
<style scoped lang="less">
@import "../../assets/css/edit.less";
/deep/ div .el-drawer__body {
  padding: 0 !important;
}
.pay-mains {
  .titles-head {
    border-top: 0;
  }
  .order-details {
    height: 56px;
    line-height: 56px;
    background: #F7F8FA;
  }
}
.dialog-staff-box {
  .body-content {
    .deduct-amount {
      display: flex;
      justify-content: space-between;
      margin: 0 30px;
      font-size: 16px;

      
    }
    .body-title {
      text-align: right;
      color: #2795fd;
      cursor: pointer;
      i {
        margin-right: 9px;
      }
    }
    .boxs {
      margin: 0 29px;
      font-size: 16px;
      .box {
        margin-top: 20px;
        background-color: #f3f3f3;
        border-radius: 4px;
        color: #282828;
        display: flex;
        align-items: center;
        .flex {
          flex: 1;
          margin-right: 42px;
          .staffs-msg {
            padding-top: 20px;
            display: flex;
            justify-content: space-between;
            // align-items: center;
            .img {
              cursor: pointer;
            }
            .staff-name {
              display: flex;
              align-items: center;
            }
            .add-img {
              width: 35px;
              vertical-align: middle;
              position: relative;
              &::before {
                content: "+";
                position: absolute;
                font-size: 24px;
                height: 35px;
                top: 0;
                left: 0;
                width: 35px;
                text-align: center;
              }
            }
            .notStaff {
              position: relative;
              background-size: 100% 100%;
              background-repeat: no-repeat;
              width: 133px;
              height: 33px;
              cursor: pointer;
              display: flex;
              justify-content: center;
              .span {
                left: 45px;
                position: absolute;
                height: 33px;
                display: flex;
                align-items: center;
                &::before {
                  content: "+";
                  font-size: 24px;
                  position: absolute;
                  left: -20px;
                  color: #333;
                  height: 35px;
                  top: 0;
                }
              }
            }
          }
          .deduct-msg {
            padding: 20px 0;
            display: flex;
            justify-content: space-between;
          }
          .label {
            margin-left: 26px;
          }
        }
        .close {
          margin-right: 20px;
          font-size: 25px;
          cursor: pointer;
        }
      }
    }
  }
}
</style>